import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";

export default class PayPeriodPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = {},
			title,
		} = options;

		$ctrl.request = {
			id: request.id,
			status: request.status,
			startOn: request.startOn
				? moment(request.startOn)
				: moment(),
      endOn: request.endOn
				? moment(request.endOn)
				: moment(),
//			tags: request.tags || [],
		};
		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} Pay Period...`;
	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;

		$ctrl.bus
			.send(`${$ctrl.action}PayPeriod.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("payperiodSaved", $ctrl);
				$ctrl.$emit("refresh-payperiods", response);
				$ctrl.$close(response.data);
			});
	}

	delete() {
		const $ctrl = this;
		$ctrl.$close($ctrl.request);
		return modals
			.confirm("Please confirm that you would like to delete this Pay Period.", "Delete Pay Period")
			.result.then(function () {
				$ctrl.bus
					.send("DeletePayPeriod.json", $ctrl.request)
					.then(function (response) {
						$ctrl.$emit("payperiodDeleted", $ctrl);
						$ctrl.$emit("refresh-payperiods", response);
					});
			});
	}
	
	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
